<template>
  <div>
    <div v-if="!isLoading">
      <h3 class="text-center pb-4" v-if="stockList.length == 0">
        Report List is Empty
      </h3>
    </div>
    <div class="text-center pb-4" v-if="isLoading">
      <v-progress-circular
        :size="50"
        color="grey"
        indeterminate
      ></v-progress-circular>
    </div>

    <div v-if="!$vuetify.breakpoint.xsOnly">
      <v-row class="list" v-for="item in stockList" :key="item.id">
        <v-col cols="1" class="my-auto ml-4">
          <v-img :src="item.stock_logo" class="img"></v-img>
        </v-col>
        <v-col cols="6" class="my-auto ml-2">
          <div class="security-name">{{ item.stock_name }}</div>
          <!-- <div class="sub-text">By {{item.posted_by_name}}</div> -->
        </v-col>
        <v-col cols="2" class="my-auto ml-8">
          <div class="sub-text">Starts from</div>
          <div class="rupee-text">₹ {{ item.minimum_stock_price }}</div>
        </v-col>
        <v-col cols="2" class="my-auto">
          <v-btn color="primary text-none" @click="openReportList(item)"
            >Explore</v-btn
          >
        </v-col>
      </v-row>
    </div>
    <div v-else>
      <v-row class="list" v-for="item in stockList" :key="item.id">
        <v-col cols="2" class="my-auto ml-2">
          <v-img :src="item.stock_logo" class="img"></v-img>
        </v-col>
        <v-col cols="9" class="my-auto ml-2">
          <div class="security-name">{{ item.stock_name }}</div>
          <!-- <div class="sub-text">By {{item.posted_by_name}}</div> -->
        </v-col>
        <v-col class="d-flex ml-2 justify-space-between">
          <div>
            <div class="sub-text mt-1">Starts from</div>
            <div class="rupee-text">₹ {{ item.minimum_stock_price }}</div>
          </div>
          <div>
            <v-btn
              color="primary"
              @click="openReportList(item)"
              class="explore-btn-mobile text-none"
              >Explore</v-btn
            >
          </div>
        </v-col>
      </v-row>
    </div>

    <ReportListDialog />
  </div>
</template>
<script>
import newAxios from "@/api/newAxios";
import apiUrl from "@/common/apiUrl";
export default {
  name: "StockReportList",
  data() {
    return {
      confirmation_icon: require("@/assets/confirmation_icon.svg"),
      empty_mobile: require("@/assets/images/portfolioEvaluation/emptyStateMobile.svg"),
      stockList: [],
      isLoading: true,
    };
  },
  components: {
    ReportListDialog: () =>
      import("@/components/Trending/ResearchReport/ReportsListDialog.vue"),
  },
  mounted() {
    this.getStockList();
  },
  methods: {
    openReportList(item) {
      this.$store.commit("ResearchReport/toggleReportListModal", {
        show: true,
        item: item,
      });
    },
    getStockList() {
      console.log("api call");
      const onSuccess = (res) => {
        this.isLoading = false;
        this.stockList = res.data.data;
      };
      const onFailure = () => {};
      let formData = {};
      formData["filter_by"] = "stock";
      newAxios("get", apiUrl.GET_RESEARCH_REPORT, {
        params: formData,
        onSuccess,
        onFailure,
        isTokenRequired: true,
      });
    },
  },
};
</script>
<style scoped>
.img {
  height: 52px;
  width: 52px;
  border: 1px solid #e4e4e4;
  border-radius: 50%;
}

.list {
  margin-left: 1%;
  margin-bottom: 1%;
  width: 98%;
  height: 76px;
  background-color: white;
  border: 1px solid #e4e4e4;
  border-radius: 12px;
}

.security-name {
  font-family: Avenir;
  font-size: 20px;
  font-weight: 500;
  line-height: 27.32px;
  color: #333333;
}

.sub-text {
  font-family: Avenir;
  font-size: 14px;
  font-weight: 500;
  line-height: 19.12px;
  color: grey;
}

.rupee-text {
  font-family: Avenir;
  font-size: 16px;
  font-weight: 800;
  line-height: 21.86px;
  color: #333333;
}
.explore-btn-mobile {
  width: 160px;
  border-radius: 4px;
}
@media only screen and (max-width: 600px) {
  .img {
    height: 44px;
    width: 44px;
  }

  .list {
    height: auto;
    /* Adjust height for mobile view */
    padding: 10px;
    /* Add some padding */
  }

  .security-name {
    font-size: 14px;
    /* Decrease font size */
  }

  .rupee-text,
  .sub-text {
    margin-left: 5px;
    /* Add space for better alignment */
  }

  .v-btn {
    margin-top: 10px;
  }
  .security-name {
    font-family: Avenir;
    font-size: 16px;
    font-weight: 800;
    line-height: 27.32px;
    color: #333333;
  }
}
</style>
